<!-- Ultimately would want to make this something better than a basic modal. Potentially a new route /device/serial with its own page. -->


<template>
  <div>
  <ConfirmModal
    v-model="isModalVisible"
    @confirm=confirmModal
    @cancel=closeModal
  >
    <template v-slot:title>Device</template>
    <template v-slot:confirm>Ok</template>
    <template v-slot:cancel>Exit</template>
    <table v-if="device" class="ui table">
        <thead>
          <tr>
            <th v-for="(attr, index) in Object.keys(device)"
            :key="attr"
            :id="'attr-' + index">{{ attr }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
          <td v-for="(attr, index) in Object.keys(device)"
            :key="attr"
            :id="'device-' + index">{{device[attr]}}</td>
          </tr>
        </tbody>
      </table>
  </ConfirmModal>
  </div>
</template>

<script>
import ConfirmModal from './ConfirmModal.vue';
export default {
  name: 'Device',
  data() {
    return {
      isModalVisible: false,
      device: null
    }
  },
  methods: {
    showModal(device) {
      console.log(device);
      this.device = device;
      this.isModalVisible = true;
    },
    closeModal() {
      // TODO if closed modal should call logout function and drop them on home page
      this.isModalVisible = false;
    },
    confirmModal() {
      this.isModalVisible = false;
      // this.oktaAuth.signInWithRedirect();
    },
  },
  components: {
    ConfirmModal
  },
  inheritAttrs: false,
}
</script>